import React, { useContext } from 'react';
import { ApiContext } from 'Services/api-context';
import { ServiceProviderProps } from './common';
import { ICommissionService, CommissionServiceContext } from 'Services/commission';

export const CommissionServiceProvider:
React.FC<ServiceProviderProps<ICommissionService>> = ( props, context ) => {
  const api = useContext( ApiContext );
  const commissionService: ICommissionService = new props.useClass( api );

  return (
    <CommissionServiceContext.Provider value={ commissionService }>
      { props.children }
    </CommissionServiceContext.Provider>
  );
};
